import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";

import { branchsSlice } from "../app/modules/MasterData/_redux/branchs/branchsSlice";
import { projectsSlice } from "../app/modules/MasterData/_redux/projects/projectsSlice";
import { channelsSlice } from "../app/modules/MasterData/_redux/channels/channelsSlice";

import { donationSlice } from "../app/modules/Donation/_redux/donation/donationSlice";
import { bankImportSlice } from "../app/modules/Donation/_redux/bank-import/bankImportSlice";
import { bankKurbanSlice } from "../app/modules/Donation/_redux/bank-kurban/bankKurbanSlice";
import { donaturSlice } from "../app/modules/Donatur/_redux/donatur/donaturSlice";
import { bankSlice } from "../app/modules/MasterData/_redux/bank/bankSlice";
import { programSlice } from "../app/modules/MasterData/_redux/program/programSlice";
import { userSlice } from "../app/modules/MasterData/_redux/user/userSlice";
import { fundTypeSlice } from "../app/modules/MasterData/_redux/fund_type/fundtypeSlice";
import { collectorSlice } from "../app/modules/Collector2/_redux/collectorSlice";
import { checkerSlice } from "../app/modules/Checker/_redux/checkerSlice";
import { confirmationSlice } from "../app/modules/Donation/_redux/confirmation/confirmationSlice";
import { voidSlice } from "../app/modules/Donation/_redux/void/voidSlice";
import { trashSlice } from "../app/modules/Donation/_redux/trash/trashSlice";
import { pickupSlice } from "../app/modules/Donation/_redux/pickup/pickupSlice";
import { eChannelSlice } from "../app/modules/Donation/_redux/echannel/eChannelSlice";
import { eChannelKurbanSlice } from "../app/modules/Donation/_redux/echannel-kurban/eChannelKurbanSlice";
import { templateSlice } from "../app/modules/MasterData/_redux/notification-template/templateSlice";
import { masterCategorySlice } from "../app/modules/MasterData/_redux/master-category/MasterCategorySlice";
import { recapSlice } from "../app/modules/Donation/_redux/recap/recapSlice";
import { kurbanSlice } from "../app/modules/Donation/_redux/kurban/kurbanSlice";
import { notificationConsolidationSlice } from "../app/modules/Donation/_redux/notification-consolidation/notificationConsolidationSlice";

import { consolidationSlice } from "../app/modules/Donation/_redux/master-consolidation/consolidationSlice";
import { exportListSlice } from "../app/modules/ExportList/_redux/exportListSlice";
import { printConsolidationSlice } from "../app/modules/Donation/_redux/PrintConsolidation/PrintConsolidationSlice";
import { departmentSlice } from "../app/modules/MasterData/_redux/department/departmentSlice";
import { goodsCategorySlice } from "../app/modules/MasterData/_redux/goods-category/goodsCategorySlice";
import { counterRecapSlice } from "../app/modules/Donation/_redux/counter-recap/counterRecapSlice";
import { donorGrowthSlice } from "../app/modules/Analysis/_redux/DonorGrowth/DonorGrowthSlice";
import { donorRankingSlice } from "../app/modules/Analysis/_redux/DonorRanking/DonorRankingSlice";
import { donorActiveSlice } from "../app/modules/Analysis/_redux/DonorActive/DonorActiveSlice";
import { counterRankingSlice } from "../app/modules/Analysis/_redux/CounterRanking/CounterRankingSlice";
import { autoSettleSlice } from "../app/modules/MasterData/_redux/auto-settle/AutoSettleSlice";
import { bankPoolingSlice } from "../app/modules/MasterData/_redux/bank-pooling/bankPoolingSlice";
import { reconcileSlice } from "../app/modules/Donation/_redux/reconcile/reconcileSlice";
import { oAuthAppSlice } from "../app/modules/MasterData/_redux/oauth-app/oAuthSlice";
import { masterOptionSlice } from "../app/modules/MasterData/_redux/master-option/masterOptionSlice";
import { accessRoleSlice } from "../app/modules/MasterData/_redux/access-role/accessRoleSlice";
import { hewanKurbanSlice } from "../app/modules/Donation/_redux/hewan-kurban/hewanKurbanSlice";
import { periodeKurbanSlice } from "../app/modules/Donation/_redux/periode-kurban/periodeKurbanSlice";
import { hewanKurbanCampaignSlice } from "../app/modules/Donation/_redux/hewan-kurban-campaign/hewanKurbanCampaignSlice";
import { cilkurSlice } from "../app/modules/Donation/_redux/cilkur/cilkurSlice";
import { paymentGatewaySlice } from "../app/modules/MasterData/_redux/payment-gateway/pgSlice";
import { paymentMethodSlice } from "../app/modules/MasterData/_redux/payment-method/pmSlice";
import { bankAccountSlice } from "../app/modules/MasterData/_redux/bank-account/bankAccountSlice";
import { organizationSlice } from "../app/modules/Organization/_redux/organization/organizationSlice";
import { importMutationBankSlice } from "../app/modules/Donation/_redux/import-mutation-bank/importMutationBankSlice";
import { importDonationSlice } from "../app/modules/Donation/_redux/import-donation/importDonationSlice";
import { benefisCategorySlice } from "../app/modules/BenefisCategory/_redux/benefisCategory/benefisCategorySlice";
import { benefisSlice } from "../app/modules/Benefis/_redux/benefis/benefisSlice";
import { projectSlice } from "../app/modules/Project/_redux/project/projectSlice";
import { projectCategorySlice } from "../app/modules/ProjectCategory/_redux/projectCategory/projectCategorySlice";
import { planUsageLogSlice } from "../app/modules/PlanUsageLog/_redux/planUsageLogSlice";
import { billingSlice } from "../app/modules/Billing/_redux/billingSlice";
import { topUpSlice } from "../app/modules/TopUp/_redux/topUpSlice";
import { planBalanceSlice } from "../app/modules/PlanBalance/_redux/planBalanceSlice";
import { partnerSlice } from "../app/modules/Partner/_redux/partnerSlice";
import { areaSlice } from "../app/modules/Area/_redux/areaSlice";
import { partnerQuotaSlice } from "../app/modules/PartnerQuota/_redux/partner-quota-slice";
import { mergingListSlice } from "../app/modules/MergingList/_redux/mergingListSlice";
import { distributionNormalSlice } from "../app/modules/Distribution/Normal/_redux/normalSlice";
import { undistributedSlice } from "../app/modules/Donation/_redux/undistributed/undistributedSlice";
import { distributionMergingSlice } from "../app/modules/Distribution/Merging/_redux/mergingSlice";
import { kurbanReportSlice } from "../app/modules/Donation/pages/kurban/_redux/report/kurbanReportSlice";
import { campaignTemplateSlice } from "../app/modules/Campaign/_redux/campaign-template/campaignTemplateSlice";
import { campaignBatchSlice } from "../app/modules/Campaign/_redux/campaign-batch/campaignBatchSlice";
import { superAdminOrganizationSlice } from "../app/modules/SuperAdmin/_redux/organization/organizationSlice";
import { organizationFileSlice } from "../app/modules/OrganizationFile/_redux/organizationFileSlice";
import { superAdminDashboardSlice } from "../app/modules/SuperAdmin/_redux/dashboard/dashboardSlice";
import { superAdminLogLoginSlice } from "../app/modules/SuperAdmin/_redux/log-login/logLoginSlice";
import { superAdminLibrarySlice } from "../app/modules/SuperAdmin/_redux/library/librarySlice";
import { organizationLibrarySlice } from "../app/modules/Library/_redux/librarySlice";
import { superAdminNotificationSlice } from "../app/modules/SuperAdmin/_redux/notification/notificationSlice";
import { superAdminNotificationTemplateSlice } from "../app/modules/SuperAdmin/_redux/notification-template/notificationTemplateSlice";
import { superAdminOrganizationReportSlice } from "../app/modules/SuperAdmin/_redux/organization-report/organizationReportSlice";
import { organizationFeatureSlice } from "../app/modules/SuperAdmin/_redux/organization-feature/organizationFeatureSlice";
import { organizationReportSlice } from "../app/modules/OrganizationReport/_redux/organizationReportSlice";
import { superAdminConsolidationReportSlice } from "../app/modules/SuperAdmin/_redux/consolidation-report/consolidationReportSlice";
import { superAdminConsolidationExportSlice } from "../app/modules/SuperAdmin/_redux/consolidation-export/consolidation-export-slice";
import { superAdminRecapitulationReportSlice } from "../app/modules/SuperAdmin/_redux/recapitulation-report/recapitulationReportSlice";
import { superAdminProgramReportSlice } from "../app/modules/SuperAdmin/_redux/program-report/programReportSlice";
import { superAdminOrganizationClassificationSlice } from "../app/modules/SuperAdmin/_redux/organization-classification/organizationClassificationSlice";
import { superAdminOrganizationRegionalSlice } from "../app/modules/SuperAdmin/_redux/organization-regional/organizationRegionalSlice";
import { superAdminAccessRoleSlice } from "../app/modules/SuperAdmin/_redux/access-role/accessRoleSlice";
import { superAdminMasterDataUserSlice } from "../app/modules/SuperAdmin/_redux/master-data-user/masterDataUserSlice";
import { superAdminOrganizationCategorySlice } from "../app/modules/SuperAdmin/_redux/organization-category/organizationCategorySlice";

// import {reportSlice} from '../app/modules/Report'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  branchs: branchsSlice.reducer,
  projects: projectsSlice.reducer,
  donaturs: donaturSlice.reducer,
  channels: channelsSlice.reducer,
  donations: donationSlice.reducer,
  bankImport: bankImportSlice.reducer,
  bankKurban: bankKurbanSlice.reducer,
  eChannel: eChannelSlice.reducer,
  eChannelKurban: eChannelKurbanSlice.reducer,
  banks: bankSlice.reducer,
  programs: programSlice.reducer,
  fundtypes: fundTypeSlice.reducer,
  users: userSlice.reducer,
  collects: collectorSlice.reducer,
  checkers: checkerSlice.reducer,
  confirmations: confirmationSlice.reducer,
  voids: voidSlice.reducer,
  trashs: trashSlice.reducer,
  pickups: pickupSlice.reducer,
  notificationTemplate: templateSlice.reducer,
  masterCategory: masterCategorySlice.reducer,
  recapSlice: recapSlice.reducer,
  masterConsolidation: consolidationSlice.reducer,
  kurbanList: kurbanSlice.reducer,
  notificationConsolidationList: notificationConsolidationSlice.reducer,
  printConsolidation: printConsolidationSlice.reducer,
  exportList: exportListSlice.reducer,
  departments: departmentSlice.reducer,
  goodsCategories: goodsCategorySlice.reducer,
  counterRecap: counterRecapSlice.reducer,
  donorGrowth: donorGrowthSlice.reducer,
  donorRanking: donorRankingSlice.reducer,
  donorActive: donorActiveSlice.reducer,
  counterRanking: counterRankingSlice.reducer,
  autoSettle: autoSettleSlice.reducer,
  bankPoolings: bankPoolingSlice.reducer,
  bankAccounts: bankAccountSlice.reducer,
  reconcile: reconcileSlice.reducer,
  oauthApp: oAuthAppSlice.reducer,
  masterOptions: masterOptionSlice.reducer,
  accessRoles: accessRoleSlice.reducer,
  hewanKurbans: hewanKurbanSlice.reducer,
  hewanKurbanCampaigns: hewanKurbanCampaignSlice.reducer,
  cilkur: cilkurSlice.reducer,
  paymentGateway: paymentGatewaySlice.reducer,
  paymentMethod: paymentMethodSlice.reducer,
  periodeKurbans: periodeKurbanSlice.reducer,
  organizations: organizationSlice.reducer,
  importMutationImportMutationBanks: importMutationBankSlice.reducer,
  importDonations: importDonationSlice.reducer,
  benefisCategory: benefisCategorySlice.reducer,
  benefis: benefisSlice.reducer,
  project: projectSlice.reducer,
  projectCategory: projectCategorySlice.reducer,
  planUsageLog: planUsageLogSlice.reducer,
  billing: billingSlice.reducer,
  topUp: topUpSlice.reducer,
  planBalance: planBalanceSlice.reducer,
  partner: partnerSlice.reducer,
  partnerQuota: partnerQuotaSlice.reducer,
  area: areaSlice.reducer,
  mergingList: mergingListSlice.reducer,
  distributionNormal: distributionNormalSlice.reducer,
  undistributed: undistributedSlice.reducer,
  distributionMerging: distributionMergingSlice.reducer,
  kurbanReport: kurbanReportSlice.reducer,
  campaignTemplate: campaignTemplateSlice.reducer,
  campaignBatch: campaignBatchSlice.reducer,
  superAdminOrganization: superAdminOrganizationSlice.reducer,
  organizationFile: organizationFileSlice.reducer,
  superAdminDashboard: superAdminDashboardSlice.reducer,
  superAdminLibrary: superAdminLibrarySlice.reducer,
  superAdminLogLogin: superAdminLogLoginSlice.reducer,
  organizationLibrary: organizationLibrarySlice.reducer,
  superAdminNotification: superAdminNotificationSlice.reducer,
  superadminNotificationTemplates: superAdminNotificationTemplateSlice.reducer,
  organizationFeatures: organizationFeatureSlice.reducer,
  organizationFiles: organizationFileSlice.reducer,
  organizationReports: organizationReportSlice.reducer,
  superAdminOrganizationReport: superAdminOrganizationReportSlice.reducer,
  superAdminConsolidationReport: superAdminConsolidationReportSlice.reducer,
  superAdminConsolidationExport: superAdminConsolidationExportSlice.reducer,
  superAdminProgramReport: superAdminProgramReportSlice.reducer,
  superAdminRecapitulationReport: superAdminRecapitulationReportSlice.reducer,
  superAdminOrganizationClassification:
    superAdminOrganizationClassificationSlice.reducer,
  superAdminOrganizationRegional: superAdminOrganizationRegionalSlice.reducer,
  superAdminAccessRole: superAdminAccessRoleSlice.reducer,
  superAdminMasterDataUser: superAdminMasterDataUserSlice.reducer,
  superAdminOrganizationCategory: superAdminOrganizationCategorySlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
